<div *ngIf="show" class="d-flex align-items-center m-2 text-secondary">
  <strong>{{ label | localize }}</strong>
  <div
    class="spinner-border"
    [ngClass]="{
     'ms-auto': !spinnerNextToText,
     'mx-3': spinnerNextToText
     }"
  ></div>
</div>
